'use client';

import AkkaLink from '@commons/AkkaLink/AkkaLink';

export default function SiteHeaderLogo({ children }) {
  return (
    <AkkaLink className="SiteHeader__logo-link" href="/">
      {children}
    </AkkaLink>
  );
}
